export const iconFontAwesomeHouseholdHouseSignal = (
	<i className="fa-solid fa-house-signal"></i>
);
